import Proxy from '../Proxy';

class SalaryCleanerBaseProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('salary/orders-base', parameters);
  }
}

export default SalaryCleanerBaseProxy;
